import makeStyles from "@mui/styles/makeStyles";

export default makeStyles(
  (theme) => ({
    root: {
      position: "relative",
      zIndex: 0,
    },
    personHead: {
      marginBottom: 10,
      maxWidth: 56,
      display: "block",
      [theme.breakpoints.up("mobile")]: {
        maxWidth: 86,
      },
      fill: theme.palette.relatives.default.background,
    },
    clickable: {
      cursor: "pointer",
    },
  }),
  { name: "DisplayFace" },
);
